// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"bem_a bie_b bie_va bie_rv bie_rw bie_vu","PanelFooter--link":"bem_b"};